import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type {
    JourneyData,
} from "../types/journey.types";

interface JourneyState {
    journey: JourneyData | null;
    prefilledCity: string | null;
    prefilledState: string | null;
}

const initialState: JourneyState = {
    journey: null,
    prefilledCity: null,
    prefilledState: null,
};

const journeySlice = createSlice({
    name: "journey",

    initialState,

    reducers: {

        setJourney(
            state,
            action: PayloadAction<JourneyData>
        ) {
            state.journey = action.payload;
        },

        clearJourney(state) {
            state.journey = null;
            state.prefilledCity = null;
            state.prefilledState = null;
        },

        setAddressPrefill(
            state,
            action: PayloadAction<{
                city: string;
                state: string;
            }>
        ) {
            state.prefilledCity = action.payload.city;
            state.prefilledState = action.payload.state;
        },

        clearAddressPrefill(state) {
            state.prefilledCity = null;
            state.prefilledState = null;
        },

    },
});

export const {
    setJourney,
    clearJourney,
    setAddressPrefill,
    clearAddressPrefill,
} = journeySlice.actions;

export default journeySlice.reducer;